module.exports = __webpack_public_path__ + "img/chuteira-bola.d538ab0b.svg";